import { Component, Input, Optional } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { PlycaDataService } from '../../services/plyca.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { finalize } from 'rxjs/operators';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseWidget } from './baseWidget';

@Component({
  selector: 'tableComponent',
  templateUrl: 'table.template.html',
  providers: [DialogService]
})

export class tableComponent extends BaseWidget {
  // @Input() link: string;
  // @Input() layoutClass: string;

  // // El componente puede recibir directamente los datos, o bien el identificador de un atributo para consultarlos
  // @Input() attributeId: string;
  //@Input() attributeParams: string;
  @Input() attributeValues: any; // si no llega el atributeId tendrian que llegar los datos
  // @Input() titleKey: string;

  @Input() identifier: string;
  loading = true;
  error = false;
  empty = false;
  isDialog = false;

  cabeceras: Array<string> = [];
  columnas: Array<string> = [];
  columnasOrdenadas: Array<string> = [];
  datos: Array<string> = [];
  subscription: Subscription;
  columnsTH: string[];

  constructor(public plycaService: PlycaDataService,
    @Optional() private dialogRef: DynamicDialogRef,
    @Optional() private dialogConfig: DynamicDialogConfig,
    private router: Router) {

    super();
    if (this.dialogConfig && JSON.stringify(this.dialogConfig) !== '{}') {
      this.isDialog = true;
    }
    if (this.dialogConfig && this.dialogConfig.data) {
      this.attributeId = this.dialogConfig.data.attributeId;
      this.titleKey = this.dialogConfig.data.titleKey;


      this.subscription = router.events.subscribe(e => {
        if (e instanceof NavigationEnd) {
          this.dialogRef.close();
        }
      });
    }
    if (this.dialogConfig) {
      this.identifier = this.dialogConfig['identifier'];
      if (this.dialogConfig['attributeId']) {

        this.attributeId = this.dialogConfig['attributeId'];
      }
      if (this.dialogConfig['attributeValues']) {
        this.attributeValues = this.dialogConfig['attributeValues'];

      }
    }
  }

  // ngAfterContentInit(): void {
  //   super.ngAfterContentInit();
  //   this.reloadWidget();
  // }

  reloadWidget(filtersStr?: string) {
    // CARGA DE DATOS UTILIZANDO ATRIBUTOS
    if (this.attributeId) {
      let colss = [];
      // this.columns = undefined;
      this.subscribe(this.plycaService.getAttribute(this.attributeId)
        .pipe(finalize(() => {
          console.log('finalize attrib definition');
        })),
        attrib => {
          console.log(attrib);
          this.columnsTH = [];
          attrib.resultDefinition.columns.forEach(_col => {
            colss.push(_col.name);
            this.columnsTH.push(_col.description);
          });

          if (attrib.resultDefinition.columns[0].order) {
            attrib.resultDefinition.columns.forEach(_col => {
              //colss[_col.order - 1] = _col.name.replace(/\s/g, "");
              colss[_col.order - 1] = _col.name;
              this.columnsTH[_col.order - 1] = _col.description;
            });
          }
          this.columnasOrdenadas = colss;
          console.log(this.columnasOrdenadas);


          this.subscribe(this.plycaService.getAttributeValue(this.attributeId, filtersStr),
            x => {
              this.attribute2Data(x);
              if (this.columnasOrdenadas.length > 0) {
                this.columnas = this.columnasOrdenadas;
              }
              this.loading = false;
            },
            err => {
              console.log('Error cargando widget: ' + this.attributeId);
              console.log(err);
              this.error = true;
              this.loading = false;
            },
            () => this.loading = false);
        });
    } else {


      if (this.identifier) {
        let colss = [];
        // this.columns = undefined;
        this.subscribe(this.plycaService.getAttribute(this.identifier)

          .pipe(finalize(() => {
            console.log('finalize attrib definition');
          })),
          attrib => {
            console.log(attrib);
            this.columnsTH = [];
            attrib.resultDefinition.columns.forEach(_col => {
              colss.push(_col.name);
              this.columnsTH.push(_col.description);
            });

            if (attrib.resultDefinition.columns[0].order) {
              attrib.resultDefinition.columns.forEach(_col => {
                //colss[_col.order - 1] = _col.name.replace(/\s/g, "");
                colss[_col.order - 1] = _col.name;
                this.columnsTH[_col.order - 1] = _col.description;
              });
            }
            this.columnasOrdenadas = colss;
            console.log('*********************');
            console.log(this.columnasOrdenadas);
            console.log(this.attributeValues);
            // TODO: PRUEBA CON DATOS RECIBIDOS COMO PARAMETRO
            // this.chartData = [150, 200, 341, 400];
            // this.chartLabels = ['Abierto', 'Negociado','Contrato Menor','Acuerdo Marco'];
            // this.empty = (this.chartData.length == 0);
            this.attribute2Data(this.attributeValues);

            if (this.columnasOrdenadas.length > 0) {
              this.columnas = this.columnasOrdenadas;
            }

            this.loading = false;
          });
      } else {
        // TODO: PRUEBA CON DATOS RECIBIDOS COMO PARAMETRO
        // this.chartData = [150, 200, 341, 400];
        // this.chartLabels = ['Abierto', 'Negociado','Contrato Menor','Acuerdo Marco'];
        // this.empty = (this.chartData.length == 0);
        this.attribute2Data(this.attributeValues);
        this.loading = false;
      }
    }
  }

  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.dialogRef = null;
    super.ngOnDestroy();
  }

  attribute2Data(x: any) {
    if (x && x.values) {
      let dt: Array<any> = x.values;
      // se comprueba si el servicio ha devuelto datos
      this.empty = (dt.length === 0);
      // si todo ok, recuperamos los datos
      if (!this.empty && !this.error) {
        for (let prop in dt[0].columns) {
          // filtrar la columna ID que se utilizaria como link
          if ('ID' != prop) {
            this.columnas.push(prop);
          }
          // this.cabeceras.push (prop['name']);
        }
        dt.forEach(c => {
          this.datos.push(c.columns);
        });
      }
    }
  }

  navigate() {
    console.log('navigate: ' + this.link)
    if (this.link) {
      this.router.navigate([this.link]);
    }
  }

  isLoading(): boolean {
    return this.loading;
  }

  isError(): boolean {
    return this.error;
  }

  isOK(): boolean {
    return !this.loading && !this.error && !this.empty;
  }

  isEmpty(): boolean {
    return this.empty;
  }


}
